// Shared styles for HorizontalTabs (desktop) and MobileHamburgerMenu (mobile)
// Any style changes here will be reflected in both components

// Layout dimensions
export const TAB_HEIGHT = "h-[46px]";
export const TAB_PADDING_X = "px-3";
export const TAB_PADDING_Y = "pt-[8px] pb-[8px]";
// Typography
export const TAB_TEXT_STYLE =
  "text-sm leading-5 font-normal whitespace-nowrap select-none";

// Active indicator (the blue line at bottom)
export const ACTIVE_INDICATOR_STYLE =
  "absolute bottom-0 h-[2px] bg-blue-600 dark:bg-blue-400 transition-[left,width] duration-300 ease-out pointer-events-none";

// Hover background (desktop only)
export const HOVER_BACKGROUND_STYLE =
  "bg-accent absolute flex h-[30px] items-center rounded-lg transition-[left,width,opacity] duration-300 ease-out pointer-events-none";
export const HOVER_BACKGROUND_TOP = "8px";

// Tab count badge
export const TAB_COUNT_BADGE_STYLE =
  "bg-muted-foreground/20 ml-2 rounded-full px-2 py-0.5 text-xs select-none";

// Same badge for a queue waiting on the viewer. Blue, like the sidebar pill, so
// "there is something for you here" reads the same wherever it appears.
export const TAB_ACTION_COUNT_BADGE_STYLE =
  "bg-blue-500 text-white ml-2 rounded-full px-2 py-0.5 text-xs font-medium tabular-nums select-none";

// Every surface that renders a Tab count goes through this, so a tab cannot
// come out blue on the desktop bar and grey in the mobile overflow menu.
export function tabCountBadgeStyle(tab: { countTone?: "neutral" | "action" }) {
  return tab.countTone === "action"
    ? TAB_ACTION_COUNT_BADGE_STYLE
    : TAB_COUNT_BADGE_STYLE;
}

// Tab states
export const TAB_ACTIVE_COLOR = "text-foreground";
export const TAB_INACTIVE_COLOR = "text-muted-foreground hover:text-foreground";
export const TAB_DISABLED_STYLE = "cursor-not-allowed opacity-50";

// Transitions
export const TAB_TRANSITION = "transition-colors duration-300";

// Skeleton dimensions (for loading states)
export const SKELETON_WIDTHS = [
  "w-20",
  "w-24",
  "w-20",
  "w-16",
  "w-20",
  "w-16",
  "w-20",
  "w-24",
  "w-20",
];
export const MOBILE_SKELETON_WIDTHS = ["w-16", "w-14", "w-12"];

// Combined skeleton wrapper class
export const getSkeletonWrapperClass = () => {
  return [TAB_HEIGHT, TAB_PADDING_X, TAB_PADDING_Y, "flex items-center"].join(
    " ",
  );
};
